export const RouteConstants = {
    ONBOARDING: '/on-boarding',
    CALLBACK: '/callback',
    HOME: '/',
    DASHBOARD: '/anomalies',
    UNAVAILABLE:'/unavailable',
    LOGOUT: '/logout',
    FORBIDDEN: '/forbidden', // user doesn't have access to the app
    PAGE_NOT_FOUND: '/404', // Page not found error
    MANAGE_PROFILE: '/manage-profile', // On-boarding with read only mode.
    OVERVIEW_RELATIVE_PATH: 'overview',
    OVERVIEW_ABSOLUTE_PATH: '/anomalies/overview',
    ANOMALY_RELATIVE_PATH:'list',
    SAMPLE_RELATIVE_PATH:'sample',
    ORPHAN_RELATIVE_PATH:'orphan',
    ANOMALY_ABSOLUTE_PATH:'/anomalies/list',
    SAMPLE_ABSOLUTE_PATH:'/anomalies/sample',
    ANOMALY_DETAILS : '/detail/:id',
    ANOMALY_DETAILS_ABSOLUTE_PATH : ':id',
    ANOMALY_DETAILS_RELATIVE_PATH : '/detail',
    CONTEXT : '/anomalies/context',
    LANDING_PAGE:'/landing_page',
    CUSTOM_STRATEGY : '/anomalies/customstrategy',
    DATA_GPT : '/anomalies/data_gpt',
    MODEL_REVIEW : '/anomalies/model_review',
    MERTIC_DASHBOARD:'/anomalies/metric_dashboard',
    CAMS_GPT : '/anomalies/cams_gpt',
    ORPHAN_ABSOLUTE_PATH:'/anomalies/orphan', //added newly
    CONTEXT_EDIT:'/anomalies/context/edit',
    CONTEXT_EDIT_MODEL:'/anomalies/context/edit/:id',
}

export const TabConstants = {
    OVERVIEW:'overview',
    ANOMALIES:'anomalies',
    SAMPLE:'sample',
    ORPHAN:'unassigned_anomalies',
    CONTEXT:'add_context',
    CUSTOM_STRATEGY:'new_rule_creation',
    LANDING_PAGE:'landing_page',
    DATA_GPT:'data_gpt',
    MODEL_REVIEW:'model_review',
    MERTIC_DASHBOARD:'metric_dashboard',
    CAMS_GPT:'cams_gpt'
}